import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
        path: '/404',
        name: '404',
        component: require('@/pages/common/404')
    },
    {
        path: '*',
        redirect: '404'
    },
    {
      path: '/',
      name: 'Index',
      component: require('@/pages/common/index')
    },
    {
      path: '/no',
      name: 'IndexNorway',
      component: require('@/pages/common/norway')
    },
    {
      path: '/se',
      name: 'IndexSweden',
      component: require('@/pages/common/sweden')
    },
    {
      path: '/fo',
      name: 'IndexFaroeIslands',
      component: require('@/pages/common/faroeislands')
    },
    {
      path: '/is',
      name: 'IndexIceland',
      component: require('@/pages/common/iceland')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js